var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm.isMessage
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger alert-margin",
            attrs: { role: "alert" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rounded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-label": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _vm._m(0),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-info",
            attrs: { id: "backBtn", type: "button" },
            on: { click: _vm.back },
          },
          [_vm._v("キャンセルする")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "row", attrs: { id: "register_form" } }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-8" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.register.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(1),
                _c("div", { staticClass: "col-9" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.organization.organizationName,
                        expression: "organization.organizationName",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      maxlength: "100",
                      placeholder: "組織名（必須）",
                      required: "",
                    },
                    domProps: { value: _vm.organization.organizationName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.organization,
                          "organizationName",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(2),
                _c("div", { staticClass: "col-9" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.organization.hierarchyNo,
                          expression: "organization.hierarchyNo",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.organization,
                              "hierarchyNo",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.selectHierarchy,
                        ],
                      },
                    },
                    [
                      _c("option", { attrs: { value: "0" } }, [_vm._v("Top")]),
                      _c("option", { attrs: { value: "1" } }, [_vm._v("1")]),
                      _c("option", { attrs: { value: "2" } }, [_vm._v("2")]),
                      _c("option", { attrs: { value: "3" } }, [_vm._v("3")]),
                      _c("option", { attrs: { value: "4" } }, [_vm._v("4")]),
                      _c("option", { attrs: { value: "5" } }, [_vm._v("5")]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(3),
                _c("div", { staticClass: "col-9" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.organization.parentId,
                          expression: "organization.parentId",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { required: _vm.parentRequired },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.organization,
                            "parentId",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    _vm._l(_vm.organizationOptions, function (option) {
                      return _c(
                        "option",
                        { key: option.id, domProps: { value: option.id } },
                        [_vm._v(" " + _vm._s(option.organizationName) + " ")]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(4),
                _c("div", { staticClass: "col-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.organization.belongsOrder,
                        expression: "organization.belongsOrder",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number", required: "" },
                    domProps: { value: _vm.organization.belongsOrder },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.organization,
                          "belongsOrder",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "col-7" }),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(5),
                _c("div", { staticClass: "col-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.organization.isBelongs,
                        expression: "organization.isBelongs",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.organization.isBelongs)
                        ? _vm._i(_vm.organization.isBelongs, null) > -1
                        : _vm.organization.isBelongs,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.organization.isBelongs,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.organization,
                                "isBelongs",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.organization,
                                "isBelongs",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.organization, "isBelongs", $$c)
                        }
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "col-7" }),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(6),
                _c("div", { staticClass: "col-9" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.organization.displayName,
                        expression: "organization.displayName",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      maxlength: "100",
                      readonly: !_vm.organization.isBelongs,
                      placeholder: "表示名",
                      required: "",
                    },
                    domProps: { value: _vm.organization.displayName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.organization,
                          "displayName",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(7),
                _c("div", { staticClass: "col-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.organization.isDisplayed,
                        expression: "organization.isDisplayed",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "checkbox",
                      disabled: !_vm.organization.isBelongs,
                    },
                    domProps: {
                      checked: Array.isArray(_vm.organization.isDisplayed)
                        ? _vm._i(_vm.organization.isDisplayed, null) > -1
                        : _vm.organization.isDisplayed,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.organization.isDisplayed,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.organization,
                                "isDisplayed",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.organization,
                                "isDisplayed",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.organization, "isDisplayed", $$c)
                        }
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "col-7" }),
              ]),
            ]),
            _c(
              "button",
              {
                staticClass: "btn btn-info btn btn-block",
                attrs: { id: "register_button", type: "submit" },
              },
              [_vm._v("登録する")]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-5" }, [
      _c("h5", [_vm._v("組織・所属新規作成")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("組織名")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [_c("label", [_vm._v("階層")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("親組織")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("同一階層内表示順")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("ユーザー所属")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("表示名")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("プロフィール表示")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }